import React, { useEffect, useRef, useState } from 'react';
import Divider from '@mui/material/Divider';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ContainedButton from '../Buttons/ContainedButton';
import { KeyboardArrowUp } from '@mui/icons-material';
import { Box, Checkbox, Chip, TextField, Typography } from '@mui/material';
import { StyledMenu } from '../Menu/StyledMenu';
import filter_chart from './utils/chart_filtering';

export default function FilterSecondary({
  primary_filter_name,
  secondary_filter_name,
  formatted_json_data,
  complete_paginated_data,
  update_chart_with_filtered_data,
  color_by,
  x_key_name,
  selected_filters,
  set_selected_filters,
  update_filter_type,
}) {
  // const [selected_filters, set_selected_filters] = useState({
  //   [primary_filter_name]: [],
  //   [secondary_filter_name]: []
  // });

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [primary_empty_text, set_primary_empty_text] = useState(true);
  const [secondary_empty_text, set_secondary_empty_text] = useState(true);

  const [primary_search_result, set_primary_search_result] = useState([]);
  const [secondary_search_result, set_secondary_search_result] = useState([]);

  const search_primary_filter_key_values = (text) => {
    text = text.trim();
    if (text === "") {
      set_primary_empty_text(true);
      set_primary_search_result([]);
      return;
    } else {
      set_primary_empty_text(false);
    }
  
    const secondarySelectedFilters = selected_filters[secondary_filter_name];
    let filteredData = formatted_json_data;
  
    if (secondarySelectedFilters.length > 0) {
      filteredData = formatted_json_data.filter((data) => {
        const secondaryKeyValueInJson = data[secondary_filter_name].toString();
        return secondarySelectedFilters.some((value) => value === secondaryKeyValueInJson);
      });
    }
  
    const search_results = filteredData
      .filter((data) => {
        const key_value_in_json = data[primary_filter_name].toString();
        return key_value_in_json.toLowerCase().includes(text);
      })
      .map((data) => data[primary_filter_name]);
  
    const search_set = new Set(search_results);
    set_primary_search_result(Array.from(search_set));
  };
  

  const search_secondary_filter_key_values = (text) => {
    text = text.trim();
    if (text === "") {
      set_secondary_empty_text(true);
    } else {
      set_secondary_empty_text(false);
    }
    if (!primary_empty_text && selected_filters[primary_filter_name].length > 0) {
      const search_results = formatted_json_data
        .filter((data) => {
          const key_value_in_json = data[primary_filter_name].toString();
          return selected_filters[primary_filter_name]?.some((value) => value === key_value_in_json);
        }).filter((data) => {
          const key_value_in_json = data[secondary_filter_name].toString();
          return key_value_in_json.toLowerCase().includes(text);
        })
        .map((data) => data[secondary_filter_name]);
      const search_set = new Set(search_results);
      set_secondary_search_result(Array.from(search_set));
    }
    else {
      const search_results = formatted_json_data
        .filter((data) => {
          const key_value_in_json = data[secondary_filter_name].toString();
          return key_value_in_json.toLowerCase().includes(text);
        })
        .map((data) => data[secondary_filter_name]);
      console.log({ search_results });
      const search_set = new Set(search_results);
      set_secondary_search_result(Array.from(search_set));
    }
  };

  useEffect(() => {
    search_primary_filter_key_values("");
    search_secondary_filter_key_values("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const add_remove_item_to_selected_primary_search_term = (value, isChecked) => {
    if (isChecked) {
      set_selected_filters((prev) => ({
        ...prev,
        [primary_filter_name]: Array.from(new Set([...prev[primary_filter_name], value]))
      }));
    } else {
      set_selected_filters((prev) => ({
        ...prev,
        [primary_filter_name]: prev[primary_filter_name].filter((name) => name !== value)
      }));
    }
  };

  const add_remove_item_to_selected_secondary_search_term = (value, isChecked) => {
    if (isChecked) {
      set_selected_filters((prev) => ({
        ...prev,
        [secondary_filter_name]: Array.from(new Set([...prev[secondary_filter_name], value]))
      }));
    } else {
      set_selected_filters((prev) => ({
        ...prev,
        [secondary_filter_name]: prev[secondary_filter_name].filter((name) => name !== value)
      }));
    }
  };

  let primaryTimer = useRef(null);
  let secondaryTimer = useRef(null);

  const [primary_search_text, set_primary_search_text] = useState('');
  const [secondary_search_text, set_secondary_search_text] = useState('');

  const onPrimarySearchTextInput = (e) => {
    set_primary_search_text(e.target.value);
    if (primaryTimer.current) {
      clearTimeout(primaryTimer.current);
    }
    if (e.target.value === "") {
      set_primary_empty_text(true);
      return;
    }
    primaryTimer.current = setTimeout(() => {
      search_primary_filter_key_values(e.target.value.toLowerCase().trim());
    }, 1000);
  };

  const onSecondarySearchTextInput = (e) => {
    set_secondary_search_text(e.target.value);
    if (secondaryTimer.current) {
      clearTimeout(secondaryTimer.current);
    }
    if (e.target.value === "") {
      set_secondary_empty_text(true);
      return;
    }
    secondaryTimer.current = setTimeout(() => {
      search_secondary_filter_key_values(e.target.value.toLowerCase().trim());
    }, 1000);
  };

  const handleClearFilter = () => {
    set_selected_filters({
      [primary_filter_name]: [],
      [secondary_filter_name]: []
    });
    clearFilters();
  };

  const handleApplyFilter = () => {
    // const filteredData = formatted_json_data.filter((data) => {
    //   const primaryValue = data[primary_filter_name];
    //   const secondaryValue = data[secondary_filter_name];
    //   return (
    //     selected_filters[primary_filter_name].includes(primaryValue) &&
    //     selected_filters[secondary_filter_name].includes(secondaryValue)
    //   );
    // });
    // console.log({ filteredData });
    console.log(selected_filters);
    const filtered_data = filter_chart(x_key_name, formatted_json_data, selected_filters, color_by);
    console.log({ filtered_data });
    // const paginatedData = complete_paginated_data(filter_chart, filteredData);
    update_chart_with_filtered_data(filtered_data);
    update_filter_type();
    handleClose();
  };

  const clearFilters = () => {
    const filtered_data = filter_chart(x_key_name, formatted_json_data, {}, color_by);
    console.log({ filtered_data });
    // const paginatedData = complete_paginated_data(filter_chart, filteredData);
    update_chart_with_filtered_data(filtered_data);
  };

  useEffect(() => {
    const secondarySelectedFilters = selected_filters[secondary_filter_name];
    let filteredData = formatted_json_data;
  
    if (secondarySelectedFilters.length > 0) {
      filteredData = formatted_json_data.filter((data) => {
        const secondaryKeyValueInJson = data[secondary_filter_name].toString();
        return secondarySelectedFilters.some((value) => value === secondaryKeyValueInJson);
      });
    }
  
    const primarySearchText = primary_search_text.toLowerCase().trim();
    search_primary_filter_key_values(primarySearchText);
  
    if (!primary_empty_text && secondarySelectedFilters.length > 0 && primarySearchText !== "") {
      const search_results = filteredData
        .filter((data) => {
          const key_value_in_json = data[primary_filter_name].toString();
          return key_value_in_json.toLowerCase().includes(primarySearchText);
        })
        .map((data) => data[secondary_filter_name]);
  
      const search_set = new Set(search_results);
      set_secondary_search_result(Array.from(search_set));
    } else {
      search_secondary_filter_key_values(secondary_search_text);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [primary_search_text, secondary_search_text, selected_filters]);
  

  return (
    <div>
      <ContainedButton
        id={`${primary_filter_name}-chart-filterer`}
        aria-controls={open ? `${primary_filter_name}-chart-filterer-menu` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDownIcon />}
      >
        Detailed Filtering
      </ContainedButton>
      <StyledMenu
        id={`${primary_filter_name}-chart-filterer-menu`}
        MenuListProps={{
          'aria-labelledby': `${primary_filter_name}-chart-filterer`,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <Box
          className='bg-slate-400 px-2 py-1 text-xs'
        >
          <code
          >
            NOTE: Applying this will remove the primary filter
          </code>
        </Box>
        <Box className="max-w-[350px] overflow-x-scroll">
          <Box className={`flex gap-2 justify-center items-center flex-wrap my-1 max-h-28 overflow-scroll w-full`}>
            {selected_filters[primary_filter_name].slice(0, 4).map((name, idx) => (
              <Chip onDelete={(e) => {
                add_remove_item_to_selected_primary_search_term(name, false);
              }} key={`selected_primary_filter_names_${idx}_${name}_`} label={name} />
            ))}
            {selected_filters[primary_filter_name].length > 4 && '...'}
          </Box>
          <Typography className="uppercase text-lg font-semibold">{primary_filter_name.split("_").join(" ")}</Typography>
          <Box className="flex justify-between items-center my-1">
            <Box className="my-2 flex-grow">
              <TextField
                value={primary_search_text}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                className="w-full"
                size="small"
                id={`Search ${primary_filter_name}`}
                label={`Search ${primary_filter_name}`}
                variant="outlined"
                onChange={onPrimarySearchTextInput}
              />
            </Box>
          </Box>
          {!primary_empty_text && primary_search_result.length > 0 && (
            <Typography className="my-1 px-1">Similar {primary_filter_name.split("_").join(" ")}'s</Typography>
          )}
          {!primary_empty_text && (
            <Box className="p-1 max-h-32 overflow-scroll my-1 border">
              {primary_search_result.map((value, idx) => (
                <Box key={`value-${value}-${primary_filter_name}`} className="p-2 rounded-sm my-1">
                  <Box
                    className="my-1 flex justify-between items-center"
                    key={`page-${value}-${primary_filter_name}-primary-${value}`}
                  >
                    <p>{value}</p>
                    <Checkbox
                      checked={selected_filters[primary_filter_name].some((item) => item === value)}
                      onChange={(e) => {
                        add_remove_item_to_selected_primary_search_term(value, e.currentTarget.checked);
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          {!primary_empty_text && primary_search_result.length > 0 && (
            <Box className="flex flex-end justify-between my-1">
              <Box className="ml-auto">
                <ContainedButton
                  onClick={() => {
                    // Select all primary search results
                    primary_search_result.forEach((value) => {
                      add_remove_item_to_selected_primary_search_term(value, true);
                    });
                  }}
                >
                  Select All
                </ContainedButton>
              </Box>
            </Box>
          )}
          <Divider sx={{ my: 0.5 }} />
          <Box className={`flex gap-2 justify-center items-center flex-wrap my-1 max-h-28 overflow-scroll w-full`}>
            {selected_filters[secondary_filter_name].slice(0, 4).map((name, idx) => (
              <Chip onDelete={(e) => {
                add_remove_item_to_selected_secondary_search_term(name, false);
              }} key={`selected_secondary_filter_names_${idx}_${name}_`} label={name} />
            ))}
            {selected_filters[secondary_filter_name].length > 4 && '...'}
          </Box>
          <Typography className="uppercase text-lg font-semibold">{secondary_filter_name.split("_").join(" ")}</Typography>
          <Box className="flex justify-between items-center my-1">
            <Box className="my-2 flex-grow">
              <TextField
                value={secondary_search_text}
                onKeyDown={(e) => {
                  e.stopPropagation();
                }}
                className="w-full"
                size="small"
                id={`Search ${secondary_filter_name}`}
                label={`Search ${secondary_filter_name}`}
                variant="outlined"
                onChange={onSecondarySearchTextInput}
              />
            </Box>
          </Box>
          {!secondary_empty_text && secondary_search_result.length > 0 && (
            <Typography className="my-1 px-1">Similar {secondary_filter_name.split("_").join(" ")}'s</Typography>
          )}
          {!secondary_empty_text && (
            <Box className="p-1 max-h-32 overflow-scroll my-1 border">
              {secondary_search_result.map((value, idx) => (
                <Box key={`value-${value}-${secondary_filter_name}`} className="p-2 rounded-sm my-1">
                  <Box
                    className="my-1 flex justify-between items-center"
                    key={`page-${value}-${secondary_filter_name}-secondary-${value}`}
                  >
                    <p>{value}</p>
                    <Checkbox
                      checked={selected_filters[secondary_filter_name].some((item) => item === value)}
                      onChange={(e) => {
                        add_remove_item_to_selected_secondary_search_term(value, e.currentTarget.checked);
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          {!secondary_empty_text && secondary_search_result.length > 0 && (
            <Box className="flex flex-end justify-between my-1">
              <Box className="ml-auto">
                <ContainedButton
                  onClick={() => {
                    // TODO: Select all secondary search results
                  }}
                >
                  Select All
                </ContainedButton>
              </Box>
            </Box>
          )}
          <Box className="flex flex-end justify-between my-1">
            {(selected_filters[primary_filter_name].length > 0 || selected_filters[secondary_filter_name].length > 0) && (
              <ContainedButton onClick={handleClearFilter}>Clear Filter</ContainedButton>
            )}
            <Box className="ml-auto">
              <ContainedButton onClick={handleApplyFilter}>Apply Filter</ContainedButton>
            </Box>
          </Box>
        </Box>
      </StyledMenu>
    </div>
  );
}
